import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Drop, Eye, PersonArmsSpread, Leaf, Needle, PaintBrush, Scissors, Heartbeat } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

// ===== MANICURE / BELEZA =====
const unhasSimples = [
  { id: "unha_mao", title: "Mão", price: 18, icon: PaintBrush, color: "from-pink-400 to-pink-600" },
  { id: "unha_pe", title: "Pé", price: 20, icon: PaintBrush, color: "from-rose-400 to-rose-600" },
  { id: "unha_mao_pe", title: "Mão e Pé", price: 35, icon: PaintBrush, color: "from-fuchsia-400 to-fuchsia-600" }
];

const alongamentos = [
  { id: "banho_gel", title: "Banho de Gel", price: 55, icon: Drop, color: "from-cyan-400 to-cyan-600" },
  { id: "molde_f1", title: "Molde F1", price: 90, icon: PaintBrush, color: "from-violet-400 to-violet-600" },
  { id: "acrigel", title: "Acrigel", price: 90, icon: PaintBrush, color: "from-purple-400 to-purple-600" },
  { id: "fibra_vidro", title: "Fibra de Vidro", price: 90, icon: PaintBrush, color: "from-blue-400 to-blue-600" },
  { id: "postica_realista", title: "Postiça Realista", price: 45, icon: PaintBrush, color: "from-pink-400 to-pink-600" },
  { id: "esmaltacao_gel", title: "Esmaltação em Gel", price: 45, icon: Drop, color: "from-amber-400 to-amber-600" }
];

const extrasUnha = [
  { id: "manutencao_gel", title: "Manutenção em Gel", price: 55, icon: Scissors, color: "from-teal-400 to-teal-600" },
  { id: "manutencao_fibra", title: "Manutenção de Fibra", price: 55, icon: Scissors, color: "from-emerald-400 to-emerald-600" },
  { id: "reposicao_unha", title: "Reposição de Unha (uni)", price: 5, icon: PaintBrush, color: "from-slate-400 to-slate-600" },
  { id: "remocao_unha", title: "Remoção de Unha", price: 25, icon: Scissors, color: "from-red-400 to-red-600" }
];

// ===== ESTÉTICA =====
const esteticaData = [
  { id: "drenagem_modeladora", title: "Drenagem Modeladora", price: 80, icon: Drop, color: "from-purple-500 to-violet-500" },
  { id: "drenagem_facial", title: "Drenagem Facial", price: 50, icon: Eye, color: "from-pink-400 to-rose-500" },
  { id: "drenagem_bracos", title: "Drenagem nos Braços", price: 50, icon: PersonArmsSpread, color: "from-blue-400 to-blue-600" },
  { id: "drenagem_pernas", title: "Drenagem nas Pernas", price: 75, icon: PersonArmsSpread, color: "from-indigo-500 to-purple-500" },
  { id: "drenagem_gluteos", title: "Drenagem nos Glúteos", price: 50, icon: PersonArmsSpread, color: "from-orange-400 to-orange-600" },
  { id: "limpeza_pele", title: "Limpeza de Pele", price: 50, note: "a partir de R$ 50", icon: Leaf, color: "from-green-400 to-emerald-500" },
  { id: "plastica_pes", title: "Plástica dos Pés", price: 80, icon: PaintBrush, color: "from-amber-500 to-yellow-600" },
  { id: "acupuntura", title: "Acupuntura e Auriculoterapia", price: 50, icon: Needle, color: "from-red-400 to-rose-500" }
];

// ===== EMAGRECIMENTO / BEM-ESTAR =====
const emagrecimentoData = [
  { id: "consulta_nutricional", title: "Consulta Nutricional", price: 95, icon: Heartbeat, color: "from-green-500 to-teal-500" }
];

const ServiceCard = ({ item, onBuy }) => {
  const IconComp = item.icon;
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="ticket-card bg-white border border-[#E4DFD3] rounded-2xl p-5 shadow-sm"
      data-testid={`service-card-${item.id}`}
    >
      <div className={`bg-gradient-to-br ${item.color} w-11 h-11 rounded-xl flex items-center justify-center mb-3 shadow-md`}>
        <IconComp size={22} weight="duotone" className="text-white" />
      </div>
      <h4 className="text-base font-bold text-[#042F2E] mb-1">{item.title}</h4>
      {item.note ? (
        <div className="text-lg font-black text-[#FF5A26] mb-3">{item.note}</div>
      ) : (
        <div className="text-lg font-black text-[#FF5A26] mb-3">R$ {item.price.toFixed(2)}</div>
      )}
      <Button
        onClick={() => onBuy(item)}
        className="w-full bg-[#FF5A26] hover:bg-[#E04818] text-white font-bold rounded-full py-3 text-sm"
        data-testid={`buy-service-${item.id}`}
      >
        Agendar
      </Button>
    </motion.div>
  );
};

const Services = () => {
  const navigate = useNavigate();
  const [activeSubTab, setActiveSubTab] = useState("manicure");

  const handleBuy = (item) => {
    navigate("/pix-payment", {
      state: { itemId: item.id, itemType: "product", itemInfo: { title: item.title, description: "Serviço", price: item.price } }
    });
  };

  const subTabs = [
    { id: "manicure", label: "Manicure / Beleza" },
    { id: "estetica", label: "Estética" },
    { id: "emagrecimento", label: "Emagrecimento / Bem-estar" }
  ];

  return (
    <div>
      <h2 className="text-2xl sm:text-3xl font-bold text-[#042F2E] mb-2">Serviços</h2>
      <p className="text-[#115E59] mb-6">Cuide de você no MARABU OPEN CLUB</p>

      {/* Sub-tabs */}
      <div className="flex overflow-x-auto gap-2 mb-8 pb-2 no-scrollbar">
        {subTabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveSubTab(tab.id)}
            className={`px-5 py-3 rounded-xl text-sm font-bold whitespace-nowrap transition-all border-2 ${
              activeSubTab === tab.id
                ? "bg-[#042F2E] text-white border-[#042F2E]"
                : "bg-white text-[#115E59] border-[#E4DFD3] hover:border-[#FF5A26] hover:text-[#FF5A26]"
            }`}
            data-testid={`subtab-${tab.id}`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Manicure / Beleza */}
      {activeSubTab === "manicure" && (
        <motion.div key="manicure" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <h3 className="text-base font-bold text-[#115E59] uppercase tracking-wider mb-4">Unhas Simples</h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
            {unhasSimples.map((item) => (
              <ServiceCard key={item.id} item={item} onBuy={handleBuy} />
            ))}
          </div>

          <h3 className="text-base font-bold text-[#115E59] uppercase tracking-wider mb-4">Alongamentos</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
            {alongamentos.map((item) => (
              <ServiceCard key={item.id} item={item} onBuy={handleBuy} />
            ))}
          </div>

          <h3 className="text-base font-bold text-[#115E59] uppercase tracking-wider mb-4">Extras</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {extrasUnha.map((item) => (
              <ServiceCard key={item.id} item={item} onBuy={handleBuy} />
            ))}
          </div>
        </motion.div>
      )}

      {/* Estética */}
      {activeSubTab === "estetica" && (
        <motion.div key="estetica" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {esteticaData.map((item) => (
              <ServiceCard key={item.id} item={item} onBuy={handleBuy} />
            ))}
          </div>
        </motion.div>
      )}

      {/* Emagrecimento / Bem-estar */}
      {activeSubTab === "emagrecimento" && (
        <motion.div key="emagrecimento" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {emagrecimentoData.map((item) => (
              <ServiceCard key={item.id} item={item} onBuy={handleBuy} />
            ))}
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default Services;
